<template>
  <sb-version-wrapper
    :version="$attrs.version"
  >
    <template #next>
      <timeline-next v-bind="componentProps">
        <template
          v-for="(_, name) in $slots"
          #[name]="slotProps"
        >
          <slot
            :name="name"
            v-bind="slotProps || {}"
          />
        </template>
      </timeline-next>
    </template>
    <template #current>
      <timeline-current v-bind="componentProps">
        <template
          v-for="(_, name) in $slots"
          #[name]="slotProps"
        >
          <slot
            :name="name"
            v-bind="slotProps || {}"
          />
        </template>
      </timeline-current>
    </template>
  </sb-version-wrapper>
</template>

<script>
import SbVersionWrapper from '@src/components/VersionWrapper/VersionWrapper.vue';
import TimelineCurrent from '@src/components/Timeline/current/Timeline.vue';
import TimelineNext from '@src/components/Timeline/next/Timeline.vue';

export default {
  name: 'SbTimeline',
  components: {
    SbVersionWrapper,
    TimelineCurrent,
    TimelineNext,
  },
  computed: {
    componentProps() {
      const { version, ...rest } = this.$attrs;
      return rest;
    },
  },
};
</script>
